import request from '../../utils/requests'

/**
 * Tag: HomeWork
 */

const baseUrl ="/api/HomeWork";



/**
 * 获取学生作业列表
 * @param {*} param
 * {
 *    ScheduleId Desc:课时id Required:true
 * }
 */
async function _getHomeWorkModel(param) {
  return request(baseUrl+'/getHomeWorkModel',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取教师作业
 * @param {*} param
 * {
 *    WorkTeacherId Desc: Required:true
 * }
 */
async function _getHomeWorkTeacherModel(param) {
  return request(baseUrl+'/getHomeWorkTeacherModel',{
    method: 'GET',
    params: param,
  });

}



/**
 * 保存教师作业
 * @param {*} body
 * {
 *    HomeWorkTeacherId Desc:教师作业id Required:false
 *    ClassTimeTableScheduleId Desc:课时id Required:false
 *    Title Desc:标题 Required:false
 *    Description Desc:描述 Required:false
 *    ReminderTime Desc:提醒时间 Required:false
 *    ImgUrl Desc:图片/视频地址 Required:false
 * }
 */
async function _saveTeacherHomeWork(body) {
  return request(baseUrl+'/saveTeacherHomeWork',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取学生作业点评
 * @param {*} param
 * {
 *    WorkStudnetId Desc:学生作业id Required:true
 * }
 */
async function _getHomeWorkCommentModel(param) {
  return request(baseUrl+'/getHomeWorkCommentModel',{
    method: 'GET',
    params: param,
  });

}



/**
 * 保存点评
 * @param {*} body
 * {
 *    HomeWorkStudentId Desc:学生作业id Required:false
 *    HomeWorkTeacherCommentId Desc:点评id Required:false
 *    CommentContent Desc:点评内容 Required:false
 *    CommentUrls Desc:点评图片/视频 Required:false
 * }
 */
async function _saveWorkComment(body) {
  return request(baseUrl+'/saveWorkComment',{
    method: 'POST',
    body: body,
  });

}



/**
 * 提醒通知
 * @param {*} body
 * {
 *    ClassTimeTableScheduleId Desc:课时id Required:true
 *    StudentID Desc:学员ID Required:true
 *    StudentName Desc:学员姓名 Required:true
 *    HomeWorkTeacherID Desc:作业id Required:true
 * }
 */
async function _homeWorkWarnNotice(body) {
  return request(baseUrl+'/homeWorkWarnNotice',{
    method: 'POST',
    body: body,
  });

}



/**
 * 作业提交提醒Job
 */
async function _homeWorkJobWarnNotice() {
  return request(baseUrl+'/homeWorkJobWarnNotice',{
    method: 'GET',
  });

}


/**
 * 作业管理列表
 * @param {*} body
 * {
 *    ClassTimeTableScheduleId Desc:课时id Required:true
 *    StudentID Desc:学员ID Required:true
 *    StudentName Desc:学员姓名 Required:true
 *    HomeWorkTeacherID Desc:作业id Required:true
 * }
 */
async function _getHomeWorkList(body) {
  return request(baseUrl+'/GetHomeWorkList',{
    method: 'POST',
    body: body,
  });
}


export default{
  _getHomeWorkModel,
  _getHomeWorkTeacherModel,
  _saveTeacherHomeWork,
  _getHomeWorkCommentModel,
  _saveWorkComment,
  _homeWorkWarnNotice,
  _homeWorkJobWarnNotice,
  _getHomeWorkList
}




// WEBPACK FOOTER //
// ./src/services/homeWork.js